import { create } from "zustand";
import { persist } from "zustand/middleware";

type OnboardingState = {
  hasSeenWelcome: boolean;
  resetProgress: () => void;
  setWelcomeSeen: () => void;
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      hasSeenWelcome: false,
      resetProgress: () => set({ hasSeenWelcome: false }),
      setWelcomeSeen: () => set({ hasSeenWelcome: true }),
    }),
    {
      name: "ummah-wahidah-onboarding",
    },
  ),
);
